<template>
  <div class="app-main-content quote-lookup">
    <!-- <h1>Get a registration fee estimate</h1>
    <p>
      To get a registration fee estimate please enter the vehicle details and select the type of plate
      you would like to put on your vehicle.
    </p> -->

    <div class="app-content-panels">

      <Maintenance/>
    </div>
  </div>
</template>


<script setup>
import { useHead } from '@unhead/vue';
import appConfig from '@/app.config';
import Maintenance from '@/components/Maintenance.vue';

defineOptions({
  name: 'QuoteLookup',
});

useHead({
  title: `Registration fee estimate | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: 'Get a registration fee estimate based on your vehicle details and plate type.'
    }
  ]
})
</script>
